var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegramActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "18px",
    viewBox: "0 0 22 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "telegram-dark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kepler-home",
    transform: "translate(-1525.000000, -38.000000)",
    fill: "#E07D26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1542.94831,54.9151278 L1546.14962,39.6387429 C1546.43267,38.2943794 1545.6703,37.7652945 1544.79927,38.0954663 L1525.98417,45.4358676 C1524.69908,45.9423849 1524.72142,46.6704311 1525.76661,47.0004099 L1530.57922,48.5213119 L1541.75106,41.4008964 C1542.27377,41.0483018 1542.75309,41.2472149 1542.36162,41.5998096 L1533.32484,49.8658201 L1532.97629,54.8925602 C1533.47666,54.8925602 1533.6955,54.6725261 1533.95617,54.4073086 L1536.30731,52.1147201 L1541.18519,55.751865 C1542.07856,56.2583823 1542.70993,55.9944667 1542.94978,54.9138259 L1542.94831,54.9151278 Z",
    id: "telegram-dark"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramActive);
export default __webpack_public_path__ + "static/media/telegram_active.1fe15e6158f458fed1d946834653fc95.svg";
export { ForwardRef as ReactComponent };